// latest: guozhh 2017-10-22 20:50 PM
import { Model } from 'common'
Model.define('rewardpunish.condtion', {
  proxy: {
    post: '/cpu-supplymgr/punish/saveRewardPunish',
    get: '/cpu-supplymgr/punish/oneRewardPunish'
  },
  meta: {
    approveOrg: '', // 审批组织ID
    approveOrgName: '', // 审批组织名称
    approveRejectReason: '', // 驳回原因
    approveTime: '', // 审批时间
    approver: '', // 审批人ID
    approverName: '', // 审批人ID
    code: '', // 审批单编号
    createMan: '', // 建立者ID
    createManName: '', // 建立者姓名
    createTime: '', // 创建时间
    creatorOrg: '', // 创建组织ID
    creatorOrgName: '', // 创建组织
    templateType: '', // 适用范围
    description: {
      type: 'string',
      required: true,
      nullMsg: '请填选择处理说明',
      maxLength: '2000',
      maxLengthMsg: '处理说明，最大长度不得超过1000个汉字'
    }, // 处理说明
    evaluateId: '', // 评价单ID
    feedbackId: '', // 反馈单ID
    fileId: '', // 文件ID
    handleContent: '', // 处理内容
    handleType: { type: 'string', required: true, nullMsg: '请填选择处理结果' }, // 处理ID类型
    id: '', // 唯一标识
    problemContent: '', // 问题分类名称
    problemType: '', // 问题分类ID
    source: { type: 'string', required: true, nullMsg: '请填选择认证来源' }, // 来源ID
    sourceContent: '', // 来源中文
    status: '', // 状态 1 待审核 3 已驳回 4 已处理
    supplyApply: { type: 'string', required: true, nullMsg: '请填选择供应商' }, // 供应商ID
    supplyApplyName: '', // 客商名称
    supplyType: { type: 'string', required: true, nullMsg: '请填选择供应分类' }, // 供应分类ID
    supplyTypeName: '', // 供应分类名称
    isGlobal: { type: 'string', required: true, nullMsg: '请填选择适用范围' }, // 1 集团  2 本组织
    materialClassFullpath: '', // 供应分类全路径
    supEnterpriseId: '',
    deadline: '', // 整改期限
    bankname: '',
    province: '',
    city: '',
  }
})

export default Model.create('rewardpunish.condtion')



// WEBPACK FOOTER //
// ./src/components/modalrefer/yinhang/condition.js